module.exports = __webpack_public_path__ + "media/theme/PC_top_04-ecbd610c.png";